@use "variables" as *;

.container {
  position: relative;
  display: flex;
  border-radius: 20px !important;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: 0;
    bottom: 0;
    margin: $spacing-s;
    z-index: 100;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.image {
  display: flex;
  height: 80px;
  width: 80px;
  flex-shrink: 0;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
}

.lazyImage {
  display: block;
  width: 100%;
  height: auto;
  max-height: 100%;
}

.rightContainer {
  height: 100%;
  width: 100%;
  margin-top: $spacing-s;
  margin-right: $spacing-s;
}

.name {
  font-size: $fontSize-s;
}

.years {
  font-size: $fontSize-xxs;
  font-weight: normal;
  padding-bottom: $spacing-s;
}

.profile {
  white-space: pre-wrap;
  font-size: $fontSize-xxs;
  font-weight: normal;
  margin-bottom: $spacing-s;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.hoverButton {
  width: 30px;
  height: 30px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}
